require('./brokerMyInvestmentsAssetsTable.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const Immutable = require('immutable');

const { BrokerMyInvestmentsProductsTable } = require('../brokerMyInvestmentsProductsTable/brokerMyInvestmentsProductsTable');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

const BrokerMyInvestmentsAssetsTable = props => {
    const { immStocks, type, showCompleteList, isContractSection } = props;

    return (
        <OKTable className="broker-products-table">
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell
                        asHeader={true}
                        className="broker-products-table__name"
                        width="20%"
                    >
                        <FormattedText value="broker-assetsName" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__titles"
                        width="7%"
                    >
                        <FormattedText value="broker-assetsSharesStocks" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__average-price"
                        width="8%"
                    >
                        <FormattedText value="broker-assetsAveragePrice" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__capital"
                        width="12%"
                    >
                        <FormattedText value="broker-assetstInvestedCapital" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__ratio"
                        width="11%"
                    >
                        <FormattedText value="broker-assetsNATStocks" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__value"
                        width="10%"
                    >
                        <FormattedText value="broker-assetsSharesActualValue" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__earnings"
                        width="14%"
                    >
                        <FormattedText value="broker-assetsEarnings" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__in-wallet"
                        width="9%"
                    >
                        <FormattedText value="broker-assetsInWallet" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__actions"
                        width="9%"
                    />
                </OKTableRow>
            </thead>
            <BrokerMyInvestmentsProductsTable
                type={type}
                immStocks={immStocks}
                showCompleteList={showCompleteList}
                isContractSection={isContractSection}
                onHandleBuyClick={props.onHandleBuyClick}
                pageName={props.pageName}
            />
        </OKTable>
    );
};

BrokerMyInvestmentsAssetsTable.propTypes = {
    immStocks: PropTypes.object,
    type: PropTypes.string,
    showCompleteList: PropTypes.bool,
    isContractSection: PropTypes.bool,
    alternativeValueColumnTitle: PropTypes.bool,
    onHandleBuyClick: PropTypes.func,
    pageName: PropTypes.string
};

BrokerMyInvestmentsAssetsTable.defaultProps = {
    immStocks: Immutable.List(),
    showCompleteList: false,
    alternativeValueColumnTitle: false
};

module.exports = BrokerMyInvestmentsAssetsTable;
